import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetalleUsuarioService {
  public rut: string;
  public dv: string;
  public nombre: string;
  public apellidoM: string;
  public apellidoP: string;
  private rutServ = new BehaviorSubject<string>(null);
  private funcionalidadesJson = new BehaviorSubject<string>(null);
  private swtDJ = new BehaviorSubject<string>(null);

  constructor() { }

  guardarRut(rut: string): void {
    this.rut = rut;
  }

  obtenerRut(): string {
    return this.rut;
  }

  guardarDv(dv: string): void {
    this.dv = dv;
  }

  obtenerDv(): string {
    return this.dv;
  }

  guardarNombre(nombre: string): void{
    this.nombre = nombre;
  }

  obtenerNombre(): string {
    return this.nombre;
  }

  guardarApellidoP(apellidoP: string): void{
    this.apellidoP = apellidoP;
  }

  obtenerApellidoP(): string {
    return this.apellidoP;
  }

  guardarApellidoM(apellidoM: string): void{
    this.apellidoM = apellidoM;
  }
  obtenerApellidoM(): string {
    return this.apellidoM;
  }

  getFuncionalidadesJson(): BehaviorSubject<string> {
    return this.funcionalidadesJson;
  }

  actualizarFuncionalidadesJson(valor: string): void {
    this.funcionalidadesJson.next(valor);
  }

  limpiarFuncionalidadesJson(): void {
    this.funcionalidadesJson.next(null);
  }

  getVariableCompartida(): BehaviorSubject<string> {
    return this.rutServ;
  }

  // Método para actualizar el valor de la variable compartida
  actualizarVariable(valor: string): void {
    this.rutServ.next(valor);
  }

  limpiarRut(): void {
    this.rutServ.next(null);
  }

  getSwtDJ(): BehaviorSubject<string> {
    return this.swtDJ;
  }

  actualizarSwtDJ(valor: string): void {
    this.swtDJ.next(valor);
  }

  limpiarSwtDJ(): void {
    this.swtDJ.next(null);
  }

  limpiarDatos(): void {
    this.rut = null;
    this.dv = null;
    this.nombre = null;
    this.apellidoM = null;
    this.apellidoP = null;
  }

}
